import React from 'react';

function Header() {
  return (
    <header className="bg-gradient-to-r from-blue-900 to-orange-500 text-white p-4 shadow-md">
      <div className="container mx-auto flex items-center justify-between">
        <div className="text-2xl font-bold">
          <a href="/" className="flex items-center space-x-2">
            <span className="bg-gradient-to-r from-blue-500 to-orange-500 bg-clip-text text-transparent">
              ECLIPSE
            </span>
            <span className="text-sm">COMMUNICATIONS LLC</span>
          </a>
        </div>
        <nav className="space-x-6">
          <a href="#home" className="hover:text-orange-300">Home</a>
          <a href="#about" className="hover:text-orange-300">About</a>
          <a href="#services" className="hover:text-orange-300">Services</a>
          <a href="#portfolio" className="hover:text-orange-300">Results</a>
          <a href="#contact" className="hover:text-orange-300">Contact</a>
        </nav>
      </div>
    </header>
  );
}

export default Header;